import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { accountWithWalletsAndPermissionsSchema } from '../types';

export const createGetAccountQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/account/${id}`,
		},
		response: {
			contract: zodContract(accountWithWalletsAndPermissionsSchema),
		},
	});

export const getAccountQuery = createGetAccountQuery();
